/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Clock, Crown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { auth, database } from "../firebase";
import { equalTo, get, orderByChild, query, ref } from "firebase/database";

const TrialExpired = ({ user }) => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [getCompany, setCompany] = useState([]);
  const [companyUsers, setCompanyUsers] = useState([]);
  const [amountPerUser, setAmountPerUser] = useState(0);
  const [TotalUsers, setTotalUser] = useState(0);
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await auth.signOut();
      localStorage.removeItem("userUID");
      localStorage.removeItem("userId");

      navigate("/login"); // Navigate to login page
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };
  useEffect(() => {
    if (user) {
      fetchCompany(user.companyId);
    }
  });
  const fetchCompany = async (companyId) => {
    try {
      if (!companyId) return;
      const companyRef = ref(database, `companies/${companyId}`);
      const snapshot = await get(companyRef);

      if (snapshot.exists()) {
        const companyData = snapshot.val();
        setCompany(companyData);
      }

      const usersRef = ref(database, "users"); // Reference to the 'users' node
      const usersQuery = query(
        usersRef,
        orderByChild("companyId"),
        equalTo(companyId)
      );
      try {
        const usersSnapshot = await get(usersQuery);

        if (usersSnapshot.exists()) {
          const usersData = usersSnapshot.val();
          setCompanyUsers(usersData);
          setTotalUser(Object.keys(usersData).length);
          if (Object.keys(usersData).length > 0) {
            setAmountPerUser(5);
          } else {
            setAmountPerUser(0);
          }
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };
  const handlePayNow = () => {
    const userCount = TotalUsers;
    const totalAmount = userCount * amountPerUser;
    const company = getCompany.Id;
    const user = companyUsers;
    setShowUpgradeModal(false);
    console.log(userCount, totalAmount, company, user);
    navigate("/payment", { state: { userCount, totalAmount, company, user } });
  };
  return (
    <>
      {/* Main Content Area */}
      <main className="p-6">
        <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-sm p-8">
          <div className="flex flex-col items-center text-center">
            <div className="mb-6">
              <Clock className="h-16 w-16 text-gray-400" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              Your free trial has expired.
            </h1>
            <p className="text-gray-600 mb-2">
              Your 30-day free trial has now expired.
            </p>
            <p className="text-gray-600 mb-2">
              You no longer have access to the{" "}
              {getCompany?.companyName || "your company"} dashboard. Email
              Signature,
            </p>

            <p className="text-gray-600 mb-4">Digital Card cannot be used.</p>
            <p className="text-gray-600 mb-6">
              Let's change that. To continue using{" "}
              {getCompany?.companyName || "your company"}, you will need to
              upgrade your plan.
            </p>
            <div className="flex space-x-4 w-full max-w-md">
              <button
                className="flex-1 py-2 px-4 border border-gray-300 rounded-md text-gray-500 hover:bg-gray-50 font-medium"
                onClick={() => setShowContactModal(true)} // Show contact modal
              >
                CONTACT US
              </button>
              <button
                className="flex-1 py-2 px-4 bg-orange-500 text-white rounded-md hover:bg-orange-600 font-medium"
                onClick={() => setShowUpgradeModal(true)} // Trigger upgrade modal
              >
                UPGRADE YOUR PLAN
              </button>
            </div>
            <p className="text-gray-600 mt-4">
              <a
                onClick={handleLogout}
                className="text-blue-500 hover:underline cursor-pointer"
              >
                Go to login
              </a>
            </p>
          </div>
        </div>
      </main>

      {/* Upgrade Modal */}
      {showUpgradeModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-md w-full">
            {/* Close Button (X) */}
            <button
              className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
              onClick={() => setShowUpgradeModal(false)} // Close modal on click
            >
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <div className="flex flex-col items-center p-6 border-b border-gray-200">
              <div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center mb-4">
                <Crown className="h-6 w-6 text-orange-500" />
              </div>
              <h2 className="text-xl font-bold text-gray-800">UPGRADE</h2>
              <p className="text-gray-600 mt-1">
                Please upgrade to access all the features.
              </p>
            </div>
            {/* Pricing Details */}
            <div className="p-6 bg-gray-100 rounded-lg">
              <div className="text-lg text-gray-800">Billing Summary</div>
              <div className="mt-3">
                <table className="min-w-full table-auto">
                  <thead className="border-b">
                    <tr>
                      <th className="px-4 py-2 text-left text-gray-700">
                        Description
                      </th>
                      <th className="px-4 py-2 text-left text-gray-700">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="px-4 py-2 text-gray-700">
                        <span>Total Users:</span>
                      </td>
                      <td className="px-4 py-2 text-gray-700"> {TotalUsers}</td>
                    </tr>
                    <tr>
                      <td className="px-4 py-2 text-gray-700">
                        <span>Amount Per User:</span>
                      </td>
                      <td className="px-4 py-2 text-gray-700">
                        ${amountPerUser}
                      </td>
                    </tr>
                    <tr className="border-t">
                      <td className="px-4 py-2 text-gray-700 font-semibold">
                        <span className="font-semibold">Total Amount:</span>
                      </td>
                      <td className="px-4 py-2 text-gray-700 font-semibold">
                        ${TotalUsers * amountPerUser}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="p-6 pt-0">
              <button
                className="w-full py-3 px-4 bg-orange-500 text-white rounded-md hover:bg-orange-600 font-medium flex items-center justify-center"
                onClick={handlePayNow} // Close modal on click
              >
                <Crown className="h-4 w-4 mr-2" />
                UPGRADE NOW
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Contact Modal */}
      {showContactModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-md w-full">
            {/* Close Button (X) */}
            <button
              className="absolute top-4 right-4 text-gray-600 hover:text-gray-900"
              onClick={() => setShowContactModal(false)} // Close modal on click
            >
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <div className="flex flex-col items-center p-6 border-b border-gray-200">
              <h2 className="text-xl font-bold text-gray-800">Contact Us</h2>
              <p className="text-gray-600 mt-1">
                Feel free to reach out to us.
              </p>
            </div>

            <div className="p-6">
              <div className="space-y-4">
                <p className="text-gray-700">
                  <strong>Email:</strong>{" "}
                  <a
                    href="mailto:support@multidynamic.com.au"
                    className="text-blue-600 underline"
                  >
                    support@multidynamic.com.au
                  </a>
                </p>
                <p className="text-gray-700">
                  <strong>Phone:</strong>{" "}
                  <a
                    href="tel:+18001234567"
                    className="text-blue-600 underline"
                  >
                    +1 (800) 123-4567
                  </a>
                </p>
              </div>
            </div>

            <div className="p-6 pt-0">
              <button
                className="w-full py-3 px-4 bg-gray-500 text-white rounded-md hover:bg-gray-600 font-medium flex items-center justify-center"
                onClick={() => setShowContactModal(false)} // Close modal on click
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TrialExpired;
